import { Charts } from './Charts';
import RegistrationStatusChartsDataProvider from './contexts/RegistrationStatusChartsDataContext';

const RegistrationStatusWrapper = () => {
    return (
        <RegistrationStatusChartsDataProvider>
            <Charts />
        </RegistrationStatusChartsDataProvider>
    );
};

export default RegistrationStatusWrapper;
